'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('PathUtils');
module.exports = require('./index.js').PathUtils;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/history/PathUtils.js
// module id = 924
// module chunks = 0